<script lang="ts">
	import { Checkbox } from '@Shelly/shelly-design-system';
	import type { CheckboxPropsTypes } from '@Shelly/shelly-design-system';
	import { format } from 'src/services/i18n';
	import { push } from 'svelte-spa-router';

	export let idPrefix: string;
	export let termsCheck = false;
	export let privacyPolicyCheck = false;
	export let newsletterCheck = false;
	export let disabled = false;
	export let showDataAct = true;
	export let newsletterClass = 'mb-m';
	export let checkboxVariant: CheckboxPropsTypes['variant'] = 'default';
</script>

<Checkbox
	id="{idPrefix}-terms-checkbox"
	variant={checkboxVariant}
	class="mb-s"
	size="m"
	bind:checked={termsCheck}
	{disabled}
>
	{$format('text_terms_and_conditions_agree', { default: 'I agree with the' })}
	<span
		class="link-styles inline-link hover-opacity"
		role="presentation"
		on:click={() => push('/terms-and-conditions')}
	>
		{$format('terms', { default: 'Terms and conditions' })}
	</span>
</Checkbox>

<Checkbox
	id="{idPrefix}-privacy-checkbox"
	variant={checkboxVariant}
	class="mb-s"
	size="m"
	bind:checked={privacyPolicyCheck}
	{disabled}
	aria-label={$format('privacy', { default: 'Privacy policy' })}
>
	{$format('text_privacy_policy_agree', {
		default:
			'I am aware that my personal data is processed for the purposes of the registration and the use of the application and I have read the',
	})}
	<span
		class="link-styles inline-link hover-opacity"
		role="presentation"
		on:click={() => push('/privacy-policy')}
	>
		{$format('privacy', { default: 'Privacy policy' })}
	</span>
	{#if showDataAct}
		{$format('and', { default: 'and' })}
		<span
			class="link-styles inline-link hover-opacity"
			role="presentation"
			on:click={() => push('/data-act')}
		>
			{$format('data_act', { default: 'Data Act' })}
		</span>
	{/if}
</Checkbox>

<Checkbox
	id="{idPrefix}-newsletter-checkbox"
	variant={checkboxVariant}
	class={newsletterClass}
	size="m"
	bind:checked={newsletterCheck}
	{disabled}
>
	{$format('text_newsletter_agree', {
		default:
			'I wish to receive marketing information via e-mail. I am aware that I can unsubscribe at any time.',
	})}
</Checkbox>

<style>
	.inline-link {
		font-size: inherit;
		line-height: inherit;
	}
</style>
